export declare type Address = `0x${string}`;

export const isAddress = ( value: unknown ): value is Address => typeof value === "string" && value.startsWith("0x");
